import { AgrDataSource } from '@next/core-lib/table-v2';
import { Observable } from 'rxjs';

import { FeedBalanceRow } from '../../services/feed-balance.service';

/** Table view only; quantities and saving remain owned by FeedBalanceComponent. */
export class FeedBalanceDataSource extends AgrDataSource<FeedBalanceRow> {
  constructor(private readonly rows$: Observable<FeedBalanceRow[]>) {
    super();
    this.loadingSubject.next(false);
  }

  connect(): Observable<FeedBalanceRow[]> {
    return this.rows$;
  }

  // The table unsubscribes on disconnect; the component owns the observable's lifetime.
  disconnect(): void {}
}
